
(function () {
  function initProducts(root) {
    root.querySelectorAll('.product-shell').forEach(function (shell) {
      if (shell.dataset.paProductReady === 'true') return;
      shell.dataset.paProductReady = 'true';

      var gallery = shell.querySelector('.product-gallery');
      var thumbs = gallery
        ? Array.from(gallery.querySelectorAll('.thumb'))
        : [];

      var mainImageContainer = gallery &&
        gallery.querySelector('.product-main-image');

      var prev = gallery &&
        gallery.querySelector('.gallery-prev');

      var next = gallery &&
        gallery.querySelector('.gallery-next');

      var currentIndex = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('active');
      });

      if (currentIndex < 0) currentIndex = 0;

      var imageLoads = new Map();
      var imageRequest = 0;

      function loadImage(url) {
        if (imageLoads.has(url)) {
          return imageLoads.get(url);
        }

        var pending = new Promise(function (resolve, reject) {
          var image = new Image();

          image.onload = function () {
            if (typeof image.decode === 'function') {
              image.decode()
                .catch(function () {})
                .then(function () {
                  resolve(image);
                });
            } else {
              resolve(image);
            }
          };

          image.onerror = function () {
            reject(new Error('Image could not load'));
          };

          image.src = url;
        });

        imageLoads.set(url, pending);

        pending.catch(function () {
          imageLoads.delete(url);
        });

        return pending;
      }

      var preloadQueue = [];
      var preloadStarted = false;
      var backgroundActive = 0;

      function pumpPreloads() {
        if (!shell.isConnected) return;

        while (
          backgroundActive < 2 &&
          preloadQueue.length
        ) {
          var index = preloadQueue.shift();
          var url = thumbs[index].getAttribute('data-image-url');

          if (!url || imageLoads.has(url)) continue;

          backgroundActive++;

          loadImage(url)
            .catch(function () {
              // Ignore failed background image loads.
            })
            .then(function () {
              backgroundActive--;
              pumpPreloads();
            });
        }
      }

      function preloadAll(index) {
        if (!preloadStarted) {
          preloadStarted = true;

          preloadQueue = thumbs.map(function (_, i) {
            return i;
          });
        }

        preloadQueue.sort(function (a, b) {
          return Math.abs(a - index) -
            Math.abs(b - index);
        });

        pumpPreloads();
      }

      function showImage(index) {
        if (
          !mainImageContainer ||
          index < 0 ||
          index >= thumbs.length
        ) {
          return;
        }

        var thumb = thumbs[index];

        var mediaType =
          thumb.getAttribute('data-media-type') || 'image';

        var url = thumb.getAttribute('data-image-url');

        currentIndex = index;

        var request = ++imageRequest;

        gallery.setAttribute('aria-busy', 'true');

        if (prev) {
          prev.hidden = index === 0;
        }

        if (next) {
          next.hidden = index === thumbs.length - 1;
        }

        function activate(newMedia) {
          if (
            request !== imageRequest ||
            !shell.isConnected
          ) {
            return;
          }

          var oldMedia = mainImageContainer.querySelector(
            'img, video, iframe, model-viewer'
          );

          if (
            oldMedia &&
            oldMedia.tagName === 'VIDEO'
          ) {
            oldMedia.pause();
          }

          if (oldMedia) {
            oldMedia.replaceWith(newMedia);
          } else {
            mainImageContainer.insertBefore(
              newMedia,
              prev || next || null
            );
          }

          thumbs.forEach(function (button, i) {
            button.classList.toggle(
              'active',
              i === index
            );

            button.setAttribute(
              'aria-pressed',
              String(i === index)
            );
          });

          gallery.setAttribute('aria-busy', 'false');

          preloadAll(index);
        }

        if (
          mediaType === 'video' ||
          mediaType === 'external_video'
        ) {
          var mediaId = thumb.getAttribute('data-media-id');

          var template = Array.from(
            gallery.querySelectorAll(
              'template[data-pa-media-id]'
            )
          ).find(function (item) {
            return item.getAttribute(
              'data-pa-media-id'
            ) === mediaId;
          });

          if (
            !template ||
            !template.content.firstElementChild
          ) {
            gallery.setAttribute('aria-busy', 'false');
            return;
          }

          var player =
            template.content.firstElementChild.cloneNode(true);

          if (player.tagName === 'VIDEO') {
            player.controls = true;
            player.autoplay = false;
            player.preload = 'metadata';
            player.setAttribute('playsinline', '');
          }

          activate(player);
          return;
        }

        if (!url) {
          gallery.setAttribute('aria-busy', 'false');
          return;
        }

        loadImage(url)
          .then(function () {
            if (
              request !== imageRequest ||
              !shell.isConnected
            ) {
              return;
            }

            var current =
              mainImageContainer.querySelector('img');

            var image = current
              ? current.cloneNode(false)
              : document.createElement('img');

            image.removeAttribute('srcset');
            image.removeAttribute('sizes');

            image.src = url;

            image.alt =
              thumb.getAttribute('data-image-alt') || '';

            var width =
              thumb.getAttribute('data-image-width');

            var height =
              thumb.getAttribute('data-image-height');

            if (width && height) {
              image.setAttribute('width', width);
              image.setAttribute('height', height);
            } else {
              image.removeAttribute('width');
              image.removeAttribute('height');
            }

            activate(image);
          })
          .catch(function () {
            if (request !== imageRequest) return;

            preloadAll(index);
            gallery.setAttribute('aria-busy', 'false');
          });
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          showImage(index);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          showImage(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          showImage(currentIndex + 1);
        });
      }

      var select = shell.querySelector(
        '.product-form select[name="id"]'
      );

      function updateVariant() {
        var option = select &&
          select.options[select.selectedIndex];

        if (!option) return;

        var price = shell.querySelector(
          '[data-pa-price]'
        );

        var compare = shell.querySelector(
          '[data-pa-compare-price]'
        );

        if (
          price &&
          option.hasAttribute('data-price')
        ) {
          price.textContent = option.dataset.price;
        }

        if (compare) {
          compare.textContent =
            option.dataset.comparePrice || '';

          compare.hidden =
            !option.dataset.comparePrice;

          compare.style.display =
            option.dataset.comparePrice ? '' : 'none';
        }

        var available =
          option.dataset.available === 'true';

        var stock = shell.querySelector('.stock-note');

        var add = shell.querySelector(
          '.product-form button.add'
        );

        if (stock) {
          stock.textContent = available
            ? 'In stock and ready to ship'
            : 'Currently unavailable';
        }

        if (add) {
          add.disabled = !available;

          add.textContent = available
            ? 'Add to cart'
            : 'Sold out';
        }

        var index = thumbs.findIndex(function (thumb) {
          return thumb.dataset.mediaId ===
            option.dataset.mediaId;
        });

        if (thumbs.length) {
          showImage(
            index >= 0 ? index : currentIndex
          );
        }
      }

      if (select) {
        select.addEventListener(
          'change',
          updateVariant
        );

        updateVariant();
      } else if (thumbs.length) {
        showImage(currentIndex);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initProducts(document);
      }
    );
  } else {
    initProducts(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initProducts(event.target);
    }
  );
})();

document.addEventListener('click', function (event) {
  var button = event.target.closest(
    '[data-mobile-menu-toggle]'
  );

  if (!button) return;

  var menu = document.getElementById(
    'pa-mobile-menu'
  );

  if (!menu) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  var shouldOpen =
    !menu.classList.contains('is-open');

  if (shouldOpen) {
    menu.removeAttribute('hidden');
    menu.classList.add('is-open');

    menu.style.setProperty(
      'display',
      'block',
      'important'
    );

    button.setAttribute('aria-expanded', 'true');

    document.documentElement.classList.add(
      'pa-menu-open'
    );
  } else {
    menu.classList.remove('is-open');
    menu.setAttribute('hidden', '');

    menu.style.setProperty(
      'display',
      'none',
      'important'
    );

    button.setAttribute('aria-expanded', 'false');

    document.documentElement.classList.remove(
      'pa-menu-open'
    );
  }
}, true);

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var button = document.querySelector(
    '[data-mobile-menu-toggle]'
  );

  var menu = document.getElementById(
    'pa-mobile-menu'
  );

  if (!button || !menu) return;

  menu.classList.remove('is-open');
  menu.setAttribute('hidden', '');

  menu.style.setProperty(
    'display',
    'none',
    'important'
  );

  button.setAttribute('aria-expanded', 'false');

  document.documentElement.classList.remove(
    'pa-menu-open'
  );
});

(function () {
  function initArticleGallery() {
    const articleBody = document.querySelector(
      '.article-body'
    );

    if (
      !articleBody ||
      articleBody.dataset.galleryReady === 'true'
    ) {
      return;
    }

    articleBody.dataset.galleryReady = 'true';

    const images = Array.from(
      articleBody.querySelectorAll('img')
    );

    if (!images.length) return;

    images.forEach(function (image) {
      if (image.closest('.article-gallery-item')) {
        return;
      }

      const link = document.createElement('a');

      link.className = 'article-gallery-item';

      link.href = image.currentSrc || image.src;

      link.setAttribute(
        'aria-label',
        'Enlarge image'
      );

      image.parentNode.insertBefore(
        link,
        image
      );

      link.appendChild(image);
    });

    let gallery = null;

    Array.from(articleBody.children).forEach(
      function (element) {
        let item = null;

        if (
          element.matches('.article-gallery-item')
        ) {
          item = element;
        } else if (
          element.querySelector('.article-gallery-item') &&
          element.textContent.trim() === ''
        ) {
          item = element.querySelector(
            '.article-gallery-item'
          );
        }

        if (item) {
          if (!gallery) {
            gallery = document.createElement('div');

            gallery.className =
              'article-image-gallery';

            articleBody.insertBefore(
              gallery,
              element
            );
          }

          gallery.appendChild(item);

          if (element !== item) {
            element.remove();
          }
        } else {
          gallery = null;
        }
      }
    );

    let lightbox = document.querySelector(
      '.pa-image-lightbox'
    );

    if (!lightbox) {
      lightbox = document.createElement('div');

      lightbox.className = 'pa-image-lightbox';

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      lightbox.innerHTML =
        '<button type="button" aria-label="Close image">&times;</button>' +
        '<img src="" alt="">';

      document.body.appendChild(lightbox);
    }

    document.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest(
          '.article-body .article-gallery-item'
        );

        if (link) {
          event.preventDefault();

          const preview =
            lightbox.querySelector('img');

          const thumbnail =
            link.querySelector('img');

          preview.src = link.href;

          preview.alt = thumbnail
            ? thumbnail.alt
            : '';

          lightbox.classList.add('is-open');

          lightbox.setAttribute(
            'aria-hidden',
            'false'
          );

          document.body.style.overflow = 'hidden';
          return;
        }

        if (
          event.target === lightbox ||
          event.target.closest(
            '.pa-image-lightbox button'
          )
        ) {
          lightbox.classList.remove('is-open');

          lightbox.setAttribute(
            'aria-hidden',
            'true'
          );

          lightbox.querySelector('img').src = '';

          document.body.style.overflow = '';
        }
      }
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          lightbox.classList.contains('is-open')
        ) {
          lightbox.classList.remove('is-open');

          lightbox.setAttribute(
            'aria-hidden',
            'true'
          );

          lightbox.querySelector('img').src = '';

          document.body.style.overflow = '';
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initArticleGallery
    );
  } else {
    initArticleGallery();
  }
})();
